import useComplaintSort from './useComplaintSort'

export default useComplaintSort
